/**
 * Job Comments Service
 * Handles API calls for job comments and collaboration
 */

import { apiClient } from './api';
import type { CommentDto, AddCommentRequest, EditCommentRequest } from '../application/service-provider/types/comment';

export const jobCommentsService = {
  /**
   * Get all comments for a job
   * @param jobId - The job ID
   * @returns Array of comments
   */
  async getJobComments(jobId: string): Promise<CommentDto[]> {
    const response = await apiClient.get<{ comments: CommentDto[] }>(
      `/provider/jobs/${jobId}/comments`
    );
    return response.comments;
  },

  /**
   * Add a new comment to a job
   * @param jobId - The job ID
   * @param request - Comment details
   * @returns The created comment
   */
  async addComment(jobId: string, request: AddCommentRequest): Promise<CommentDto> {
    const response = await apiClient.post<{ comment: CommentDto }>(
      `/provider/jobs/${jobId}/comments`,
      request
    );
    return response.comment;
  },

  /**
   * Edit an existing comment
   * @param commentId - The comment ID
   * @param request - Updated comment content
   * @returns The updated comment
   */
  async editComment(commentId: string, request: EditCommentRequest): Promise<CommentDto> {
    const response = await apiClient.patch<{ comment: CommentDto }>(
      `/provider/comments/${commentId}`,
      request
    );
    return response.comment;
  },
};
